import { httpMultipleActionsReducer, httpReducer, reduceReducers } from "../lib/create-action";
import {
  AUDIO_BLOCK_GET_FOR_USER,
  AUDIO_BLOCK_CREATE,
  AUDIO_BLOCK_GET,
  AUDIO_BLOCK_DELETE,
  FETCH_RECENT_AUDIO_BLOCKS,
} from "../action_managers/audio_management";
import keyBy from "lodash/keyBy";
import omit from "lodash/omit";

const initialState = { audioBlocks: {}, recentAudioBlockUUIDs: [], isLoading: false };
const getForUser = httpReducer(AUDIO_BLOCK_GET_FOR_USER, initialState, {
  success: (state, action) => ({
    ...state,
    audioBlocks: { ...state.audioBlocks, ...keyBy(action.payload.resp, "uuid") },
  }),
});

const get = httpReducer(AUDIO_BLOCK_GET, initialState, {
  success: (state, action) => ({
    ...state,
    audioBlocks: { ...state.audioBlocks, [action.data.uuid]: action.payload.resp },
  }),
});

const create = httpReducer(AUDIO_BLOCK_CREATE, initialState, {
  success: (state, action) => ({
    ...state,
    audioBlocks: { ...state.audioBlocks, [action.payload.resp.uuid]: action.payload.resp },
  }),
});

const deleteAudioBlock = httpReducer(AUDIO_BLOCK_DELETE, initialState, {
  success: (state, action) => ({
    ...state,
    audioBlocks: omit(state.audioBlocks, action.data.uuid),
    recentAudioBlockUUIDs: state.recentAudioBlockUUIDs.filter(uuid => uuid !== action.data.uuid),
  }),
});

const getAudioBlocks = httpMultipleActionsReducer([FETCH_RECENT_AUDIO_BLOCKS], initialState, {
  success: (state = {}, action) => {
    const newState = keyBy(action.payload.resp, "uuid");
    return { ...state, audioBlocks: { ...state.audioBlocks, ...newState } };
  },
});

const getRecentAudioBlocks = httpReducer(FETCH_RECENT_AUDIO_BLOCKS, initialState, {
  success: (state = {}, action) => {
    return { ...state, recentAudioBlockUUIDs: action.payload.resp.map(block => block.uuid) };
  },
});

export default reduceReducers(
  getForUser,
  get,
  create,
  deleteAudioBlock,
  getAudioBlocks,
  getRecentAudioBlocks
);
